import { useState } from 'react'
import { Container, Nav, Navbar } from 'react-bootstrap'
import { Link } from 'react-router-dom'

const UserNavbar = () => {
  const [expanded, setExpanded] = useState(false)

  return (
    <Navbar
      expanded={expanded}
      expand='lg'
      variant='dark'
      className='p-3 sticky-top'
    >
      <Container>
        <Link
          className='link-underline-dark'
          to='/'
          onClick={() => setExpanded(expanded ? false : 'expanded')}
        >
          <Navbar.Brand>
            <img
              src='/cdlbtlogo_icon.svg'
              alt='Logo'
              width='20'
              height='20'
              className='d-inline-block align-text-top'
            />{' '}
            Audio
          </Navbar.Brand>
        </Link>
        <Navbar.Toggle
          onClick={() => setExpanded(expanded ? false : 'expanded')}
          aria-controls='responsive-navbar-nav'
        />
        <Navbar.Collapse id='navbar-links'>
          <Nav className='me-auto'>
            <Link
              className='nav-link'
              to='/latest'
              onClick={() => setExpanded(false)}
            >
              Latest
            </Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  )
}
export default UserNavbar
